/**
 * Client mirror of the backend court-change-request enums (EE-386).
 *
 * The backend serializes these by `Enum.name()` (no `@JsonProperty` display values), so the wire
 * value is the constant name itself — the client uses the same constant names to avoid the
 * enum-wire-value trap (jackson-dto-conventions.md).
 */

/** What a court change request is asking for. */
export enum CourtChangeRequestKind {
  /** A court EasyEviction does not yet have. */
  NEW_COURT = 'NEW_COURT',
  /** A change to an existing court record (including its type). */
  COURT_UPDATE = 'COURT_UPDATE'
}

/** How a court change request originated. */
export enum CourtChangeRequestSource {
  /** Opened by the scheduled Notion directory sync. */
  DIRECTORY_SYNC = 'DIRECTORY_SYNC',
  /** Submitted from the in-app court-selection UI. */
  IN_APP = 'IN_APP',
  /** Opened directly by a global admin. */
  ADMIN = 'ADMIN'
}

/** The review status of a court change request. */
export enum CourtChangeRequestDecision {
  /** Awaiting a human decision — nothing changes a court while a request is PENDING. */
  PENDING = 'PENDING',
  /** Approved by a global admin; the change has been applied. */
  APPROVED = 'APPROVED',
  /** Declined by a global admin; no court was written. */
  DECLINED = 'DECLINED'
}
